import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: 'dashboard.pageTitle', icon: 'pe-7s-study', class: '' },
  { path: '/account', title: 'topNavbar.account', icon: 'pe-7s-user', class: '' },
  { path: '/printers', title: 'sidebar.printers', icon: 'pe-7s-print', class: '' },
  { path: '/request2/event', title: 'sidebar.eventRequest', icon: 'pe-7s-note2', class: '' },
  { path: '/event/my-events', title: 'sidebar.myEvents', icon: 'pe-7s-news-paper', class: '' },
  { path: '/price-list/my-pricelists', title: 'sidebar.myPricelists', icon: 'pe-7s-bookmarks', class: '' }
];

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: false
})

export class SidebarComponent implements OnInit {
  menuItems: any[];
  public date = new Date();

  constructor(private _route: ActivatedRoute) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    return $(window).width() <= 991;
  }

  isRouteActive(path: string) {
    return window.location.href.includes(path);
  }

}
